// Shared site content for Home Visit Dental Treatment – Pune
export const BRAND = {
  name: "Home Visit Dental Treatment",
  shortName: "HVDT",
  city: "Pune",
  tagline: "Care, comfort and convenience",
  phone: "+91 91563 91377",
  phoneRaw: "+919156391377",
  whatsapp: "919156391377",
  email: "homevisitdentaltreatment@gmail.com",
  address: "Serving all of Pune & PCMC City — Kothrud, Baner, Hinjewadi, Kharadi, Pimpri, Chinchwad, Wakad, Nigdi, Akurdi, Bhosari & more",
  social: {
    instagram: "https://instagram.com/home_visit_dental_treatment",
    facebook: "#",
    youtube: "https://youtube.com/channel/UCoWMpszMPy6vTRONjgL2GUg",
  },
};

export const SERVICE_CHIPS = [
  "Routine Check-up & Cleaning",
  "Toothache / Dental Pain",
  "Cavities & Decay",
  "Tooth Sensitivity",
  "Bleeding / Swollen Gums",
  "Loose / Shaking Teeth",
  "Crooked Teeth, Stains & Gaps",
  "Missing Teeth",
  "Swelling or Abscess",
  "Bad Breath (Halitosis)",
  "Kids' Tooth Pain & Decay",
  "Broken or Knocked-out Tooth",
];

export const HOW_IT_WORKS = [
  {
    num: "01",
    title: "Book an Appointment",
    desc: "Fill a short form or send a WhatsApp — our care team calls back within the hour to understand your concern.",
  },
  {
    num: "02",
    title: "Dentist Arrives at Home",
    desc: "A qualified dentist reaches your doorstep with sterilised equipment, examines you, and explains a clear plan.",
  },
  {
    num: "03",
    title: "Treatment. Smiles. Done.",
    desc: "We perform the treatment in the comfort of your living room — no queues, no clinic visits, no stress.",
  },
];

export const STATS = [
  { value: "10K+", label: "Home visits completed" },
  { value: "3,600+", label: "Smiles cared for" },
  { value: "12", label: "Specialists on panel" },
  { value: "5 yrs", label: "Of earned trust" },
];

export const SERVICES = [
  {
    slug: "checkup",
    title: "Diagnostic & Check-ups",
    desc: "Full oral examinations with portable digital X-rays — accurate diagnosis without ever leaving your living room.",
    image: "/service-checkup.png",
  },
  {
    slug: "dentures",
    title: "Denture Services",
    desc: "New custom dentures, repairs, relining and polishing — all done at home. Specially helpful for seniors who can't travel.",
    image: "/service-dentures.jpg",
  },
  {
    slug: "preventive",
    title: "Preventive Care",
    desc: "Ultrasonic scaling, polishing and deep cleaning to keep gums healthy, breath fresh and teeth strong for years to come.",
    image: "/service-preventive.jpg",
  },
  {
    slug: "pain-relief",
    title: "Pain Relief & Extractions",
    desc: "Emergency pain management, simple and surgical tooth extractions — performed safely with complete aseptic protocol.",
    image:
      "https://images.pexels.com/photos/6627535/pexels-photo-6627535.jpeg?auto=compress&cs=tinysrgb&w=1200",
  },
  {
    slug: "root-canal",
    title: "Single Sitting Root Canal Treatment",
    desc: "Painless single-sitting RCT performed with modern rotary endodontic files — done and dusted in one home visit.",
    image: "/service-root-canal.webp",
  },
  {
    slug: "restorations",
    title: "Cement Restorations & Fillings",
    desc: "Tooth-coloured composite and glass-ionomer fillings for cavities, chipping and worn-down teeth — restored naturally at home.",
    image: "/service-restoration.webp",
  },
  {
    slug: "crown-bridge",
    title: "Crown & Bridge",
    desc: "Custom-fit ceramic crowns and bridges to replace broken or missing teeth — impression-to-fitting, all done at home.",
    image: "/service-crown-bridge.jpg",
  },
  {
    slug: "rehabilitation",
    title: "Full-Mouth Rehabilitation",
    desc: "Smile reconstruction with crowns, bridges and prosthetics for patients who need comprehensive, life-changing care.",
    image: "/service-rehabilitation.jpg",
  },
  {
    slug: "kids",
    title: "Pediatric Dentistry",
    desc: "Gentle paediatric check-ups, sealants and fillings — no scary clinic visits, just kind care for your little ones at home.",
    image: "/service-kids.jpg",
  },
  {
    slug: "whitening",
    title: "Cosmetic & Whitening",
    desc: "Safe, dentist-supervised teeth whitening sessions for brighter, more confident smiles — done discreetly at home.",
    image: "/service-cosmetic.jpg",
  },
];

export const APPOINTMENT_STEPS = [
  {
    tag: "Step 1",
    title: "The Callback",
    desc: "Within an hour of your enquiry, our care coordinator calls you back to understand the patient's concern, medical history and preferred timing — then suggests the right treatment path and books your slot. No pressure, no upselling.",
  },
  {
    tag: "Step 2",
    title: "Home Consultation",
    desc: "A specialist arrives at your doorstep with a full mobile setup — sterilised tools and portable X-ray. They examine the patient, take X-rays if needed, and walk you through a transparent, written treatment plan with honest pricing. One-time paid consultation.",
  },
  {
    tag: "Step 3",
    title: "Treatment at Home",
    desc: "Once you approve the plan, we schedule the treatment at a time that suits your family — evenings and weekends included. The procedure is carried out in your own room with hospital-grade safety, sterilisation and precision — minus the queues and the stress.",
  },
];

export const DOCTORS = [
  {
    name: "Dr. Sneha Deshmukh",
    role: "Founder & Prosthodontist",
    bio: "MDS Prosthodontics from GDC Mumbai. 12+ years in geriatric dentistry, dentures and implant rehabilitation. Lead dentist for home-visit protocols.",
    image:
      "https://images.unsplash.com/photo-1669998966162-9837617177cd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHwxfHxjYXJpbmclMjBkZW50aXN0JTIwcG9ydHJhaXR8ZW58MHx8fHwxNzc3Njg5Nzc1fDA&ixlib=rb-4.1.0&q=85",
  },
  {
    name: "Dr. Rahul Patil",
    role: "Endodontist & Oral Surgeon",
    bio: "MDS Endodontics. Specialist in painless single-sitting root canals and surgical extractions. Known for gentle hands and clear communication.",
    image:
      "https://images.unsplash.com/photo-1729162128021-f37dca3ff30d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHwyfHxjYXJpbmclMjBkZW50aXN0JTIwcG9ydHJhaXR8ZW58MHx8fHwxNzc3Njg5Nzc1fDA&ixlib=rb-4.1.0&q=85",
  },
  {
    name: "Dr. Pinal Jain",
    role: "Periodontist",
    bio: "MDS Periodontology, Pune. 7+ years in gum care, deep cleaning and implant therapy. Active member of the Indian Society of Periodontology.",
    image:
      "https://dentathome.com/wp-content/uploads/2023/10/pinal.webp",
  },
  {
    name: "Dr. Aarti Kulkarni",
    role: "Paediatric Dentist",
    bio: "MDS Paedodontics. Handles our youngest patients with patience and play — because dentistry for kids should never be scary.",
    image:
      "https://dentathome.com/wp-content/uploads/2023/10/rupali-768x1024.webp",
  },
];

export const TESTIMONIALS = [
  {
    name: "Anjalee Bapat",
    area: "Kothrud",
    stars: 5,
    text: "An amazing concept — dental care at my comfort zone. I had a metal bridge and teeth scaling done at home. The doctors were punctual, gentle and very professional. No queues, no hassle.",
  },
  {
    name: "Parag Nandrekar",
    area: "Karve Nagar",
    stars: 5,
    text: "Got a single-sitting root canal and scaling done at home — completely painless and finished in one visit. The team was thoroughly professional and kind. A truly needed service for anyone who finds it hard to step out.",
  },
  {
    name: "Narasinh Bapat",
    area: "Kothrud",
    stars: 5,
    text: "Got my partial removable dentures done on both arches at home — finished in very little time. They are far more comfortable and easier to use than my previous denture. Honest pricing and skilled hands.",
  },
  {
    name: "Pallavi Apte",
    area: "Dhayari",
    stars: 5,
    text: "The whole team is skilled and empathetic. They explain every step patiently — hard to find these days. Outstanding experience start to finish.",
  },
];

export const FAQS = [
  {
    q: "What areas of Pune do you cover?",
    a: "All major Pune neighbourhoods — Kothrud, Baner, Aundh, Viman Nagar, Kharadi, Hinjewadi, Wakad, Hadapsar, Koregaon Park, Camp, Deccan, Kalyani Nagar, Shivaji Nagar, Magarpatta, Pimpri-Chinchwad, Bavdhan, NIBM, Pashan and more. Just share your locality in the form — if we serve your pincode, we'll be there.",
  },
  {
    q: "Is home dental treatment as safe as a clinic?",
    a: "Yes. We follow hospital-grade sterilisation, use autoclaved instruments, FDA-approved portable dental equipment, and disposable barriers for every visit. The clinical standards are identical to a top Pune clinic — only the location is different.",
  },
  {
    q: "Do I need a lot of space at home?",
    a: "Not at all. Any comfortable chair or bed in a well-lit room works perfectly — even a sofa is fine. Our entire mobile setup fits into two compact bags, and we set up and clean up in under 10 minutes.",
  },
  {
    q: "Are you available on Saturdays and Sundays?",
    a: "Yes. We provide treatments seven days a week by appointment — Monday to Sunday, 9 AM to 9 PM, including most public holidays for emergencies. Weekend slots are very popular with working professionals.",
  },
  {
    q: "Which treatments can actually be done at home?",
    a: "Almost everything — fillings, root canals, scaling and polishing, extractions, dentures, crowns and bridges, smile designing, paediatric dentistry, and cosmetic whitening. For complex implant surgery, we bring an implant specialist with all the essential portable instruments and equipment, right to your home.",
  },
  {
    q: "Is this suitable for elderly or bed-ridden parents?",
    a: "Absolutely — this service was built for them. We regularly treat patients in their 70s, 80s and 90s who cannot or should not travel. Families across Pune tell us it's been genuinely life-changing for their parents.",
  },
  {
    q: "Can I get a free WhatsApp consultation first?",
    a: `Of course. WhatsApp us on ${BRAND.phone} and, if necessary, we will arrange a free 10-minute video consult before you commit to a home visit — so you know exactly what to expect.`,
  },
  {
    q: "Is the cost the same as a clinic?",
    a: "Yes — clinic-level honest pricing, no hidden home-visit premium. You pay the same fair rates you'd pay at a good dental clinic in Pune. The only thing extra is your comfort.",
  },
];

export const PUNE_AREAS = [
  "Kothrud", "Baner", "Aundh", "Viman Nagar", "Kharadi", "Hinjewadi",
  "Wakad", "Hadapsar", "Koregaon Park", "Camp", "Deccan", "Kalyani Nagar",
  "Shivaji Nagar", "Magarpatta", "Model Colony", "Bavdhan",
  "Sinhagad Road", "NIBM", "Pashan", "Dhayari", "Karve Nagar",
  // PCMC areas
  "Pimpri", "Chinchwad", "Akurdi", "Nigdi", "Bhosari",
  "Pimple Saudagar", "Pimple Nilakh", "Pimple Gurav",
  "Ravet", "Tathawade", "Moshi", "Chikhli", "Punawale", "Dehu Road",
];
